export function jsonReplacer(key: number | string | symbol, value: any) {
  if (value instanceof Error) {
    const result = {};

    Object.getOwnPropertyNames(value).forEach((prop: string) => {
      result[prop] = value[prop];
    });

    return result;
  }

  return value;
}
